import React from 'react'
import importer from '@takedapdt/biolife-core/src/importer'
const PageNotFound = importer('Components/PageNotFound')

const NotFound = () => <PageNotFound />

export default NotFound
